module.exports = __webpack_public_path__ + "img/particle_motion_00083.3bb9bfed.png";